import request from "@/utils/request";

export const login = (data: any): any => {
  return request.post("/index/User/login", data);
};

export const signup = (data: any): any => {
  return request.post("/index/User/register", data);
};

export const getUserInfo = (): any => {
  return request.get("/index/User/getUserInfo");
};

export const updateNickname = (data: any): any => {
  return request.post("/index/Api/setNickName", data);
};

export const changePwd = (data: any): any => {
  return request.post("/index/User/changePwd", data);
};

export const setPayPwd = (data: any): any => {
  return request.post("/index/Api/setPayPwd", data);
};
